import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Icon as UiIcon } from '@picsio/ui';
import { Folder, Web, Label as Keyword } from '@picsio/icons';

const DropdownTreeIcon = ({ iconSpecial }) => (
  <Choose>
    <When condition={iconSpecial === 'keyword'}>
      <UiIcon size="inherit" color="inherit">
        <Keyword />
      </UiIcon>
    </When>
    <When condition={iconSpecial === 'folder'}>
      <UiIcon size="inherit" color="inherit">
        <Folder />
      </UiIcon>
    </When>
    <When condition={iconSpecial === 'website'}>
      <UiIcon size="inherit" color="inherit">
        <Web />
      </UiIcon>
    </When>
    <Otherwise>{null}</Otherwise>
  </Choose>
);

/** default props */
DropdownTreeIcon.defaultProps = {
  iconSpecial: null,
};

DropdownTreeIcon.propTypes = {
  iconSpecial: PropTypes.string,
};

export default memo(DropdownTreeIcon);
